/* SLP TrustBox loader. Attaches to every [data-slp-trustbox].
   The Trustpilot app injects Trustpilot's bootstrap script on its own, a moment after the page loads,
   and that script renders every .trustpilot-widget it finds. So this file waits for it, and only adds
   the script itself if the app never does (app removed or disabled). Either way the page ends up
   with one copy of the script, however many TrustBoxes are on it. */
(function () {
  'use strict';

  var BOOTSTRAP = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  var WAIT_FOR_APP_MS = 4000;

  function boxes() {
    return document.querySelectorAll('[data-slp-trustbox]');
  }

  function renderWithExistingScript() {
    if (!(window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function')) return false;
    Array.prototype.forEach.call(boxes(), function (box) {
      if (!box.querySelector('iframe')) window.Trustpilot.loadFromElement(box, true);
    });
    return true;
  }

  function hasScript() {
    return !!document.querySelector('script[src*="tp.widget.bootstrap"]');
  }

  function fallback() {
    if (renderWithExistingScript() || hasScript()) return;
    var script = document.createElement('script');
    script.src = BOOTSTRAP;
    script.async = true;
    document.head.appendChild(script);
  }

  function init() {
    if (!boxes().length || document.documentElement.hasAttribute('data-slp-trustbox-init')) return;
    document.documentElement.setAttribute('data-slp-trustbox-init', '');
    if (renderWithExistingScript()) return;
    window.setTimeout(fallback, WAIT_FOR_APP_MS);
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
  document.addEventListener('shopify:section:load', renderWithExistingScript);
})();
